import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
// import { colors, typography } from '../../styles';


const styles = css`
  padding:0;
  .container {
    display:flex;
    flex-flow:row wrap;
    justify-content: center;
    background: whitesmoke;
    padding: 30px;
  }
  a.Result {
    width:100%;
    padding:20px;
    transition: all .25s ease;
    border: 4px solid whitesmoke;
    background-color: white;

    @media (min-width: 480px) {
      width:50%;
    }
    @media (min-width: 768px) {
      width:33%;
    }
    @media (min-width: 991px) {
      width:25%;
    }
    img {
      transition:all .25s ease;
    }
    .Result_Media {
      width:100%;
      height:100%;
      display: flex;
      flex-flow:column nowrap;
      justify-content: center;
      img {
        width:90%;
        margin: auto;
        filter: grayscale(100%);
      }
    }
  }
  a.Result:hover {
    .Result_Media {
      img {
        filter: grayscale(0%);
      }
    }
  }
`;

function LogoGrid({ community }) {
  return (
    <section className={styles}>
      <div className="container">
        {
          get(community, 'builders').map(item => (
            <a href={item.url} target="_blank" rel="noopener noreferrer" className="Result">
              <div className="Result_Media">
                <img src={get(item, 'image.contentUrl')} alt="" />
              </div>
            </a>
          ))
        }
      </div>
    </section>
  );
}

LogoGrid.propTypes = {
  community: PropTypes.object.isRequired,
};

LogoGrid.defaultProps = {
  community: undefined,
};

export default withData(
  {
    community: true,
  },
  {
    required: {
      community: true,
    },
  },
)(LogoGrid);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/LogoGrid.js